import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { checkTokenGuard } from './auth/check-token.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./login/login').then(m => m.LoginComponent)
  },
  {
    path: '',
    loadComponent: () => import('./shell/shell').then(m => m.ShellComponent),
    canActivate: [checkTokenGuard, authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard').then(m => m.DashboardComponent)
      },
      {
        path: 'users',
        loadComponent: () => import('./users/users').then(m => m.UsersComponent)
      },
      {
        path: 'companies',
        loadComponent: () => import('./companies/companies').then(m => m.CompaniesComponent)
      },
      {
        path: 'orders',
        loadComponent: () => import('./operations/orders').then(m => m.AdminOrdersComponent)
      },
      {
        path: 'projects',
        loadComponent: () => import('./operations/projects').then(m => m.AdminProjectsComponent)
      },
      {
        path: 'audit',
        loadComponent: () => import('./operations/audit').then(m => m.AdminAuditComponent)
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];
